const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.182,11.694c-0.229-0.51-0.721-0.851-1.279-0.884c-0.57-0.042-1.089,0.246-1.376,0.725l-6.029,10.037 c-0.427,0.71-0.196,1.632,0.514,2.058c0.709,0.427,1.632,0.198,2.059-0.513l3.015-5.02c-1.091,9.994-6.258,19.954-14.562,27.831 c-9.838,9.332-22.55,14.471-35.794,14.471c-0.829,0-1.5,0.672-1.5,1.5s0.671,1.5,1.5,1.5c14.016,0,27.461-5.432,37.859-15.294 c8.736-8.286,14.214-18.788,15.453-29.383l2.238,5.002c0.249,0.557,0.797,0.888,1.37,0.888c0.205,0,0.413-0.042,0.611-0.131 c0.757-0.338,1.096-1.226,0.757-1.982L71.182,11.694z",
    id: "id_101",
    style: {
      fill: "rgb(0, 231, 212)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.102,71.432c-0.829,0-1.5,0.672-1.5,1.5v14.762c0,0.828,0.671,1.5,1.5,1.5s1.5-0.672,1.5-1.5V72.932 C19.602,72.104,18.931,71.432,18.102,71.432z",
    id: "id_102",
    style: {
      fill: "rgb(0, 231, 212)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.704,65.175c-0.829,0-1.5,0.672-1.5,1.5v21.019c0,0.828,0.671,1.5,1.5,1.5s1.5-0.672,1.5-1.5V66.675 C42.204,65.847,41.533,65.175,40.704,65.175z",
    id: "id_103",
    style: {
      fill: "rgb(0, 231, 212)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.794,50.254c-0.828,0-1.5,0.672-1.5,1.5v35.939c0,0.828,0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5V51.754 C64.294,50.926,63.622,50.254,62.794,50.254z",
    id: "id_104",
    style: {
      fill: "rgb(0, 231, 212)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.271,14.316c-0.828,0-1.5,0.671-1.5,1.5v71.877c0,0.828,0.672,1.5,1.5,1.5s1.5-0.672,1.5-1.5V15.816 C83.771,14.987,83.1,14.316,82.271,14.316z",
    id: "id_105",
    style: {
      fill: "rgb(0, 231, 212)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.d700f5d96aac78aee080d4a554e74f7f.svg";
export { ForwardRef as ReactComponent };